module.exports = __webpack_public_path__ + "blogwriting.svg?82fb8cd594e995efe64f23e904ed4eb0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/blogwriting.svg
// module id = 109
// module chunks = 0